import React from "react";
import { useTranslation } from "react-i18next";
import "./legal.css";

/**
 * Card shown read-only, with an "Edit" button switching it to a form saved
 * with `onSave` (or left with `onCancel`). Without `title` nor `onEdit`
 * (e.g. the page header holds them), the card has no header.
 */
const SectionCard = ({
  title,
  editing,
  saving,
  onEdit,
  onCancel,
  onSave,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <section className="ui-card legal-card">
      {(title || (!editing && onEdit)) && (
        <header className="legal-card-head">
          {title && <h2 className="legal-card-title">{title}</h2>}
          {!editing && onEdit && (
            <button type="button" className="ui-btn ui-btn-secondary" onClick={onEdit}>
              <i className="ri-pencil-line" aria-hidden="true"></i>
              {t("edit")}
            </button>
          )}
        </header>
      )}
      <div className="legal-card-body">{children}</div>
      {editing && (
        <footer className="legal-card-footer">
          {onCancel && (
            <button type="button" className="ui-btn ui-btn-secondary" onClick={onCancel}>
              {t("cancel")}
            </button>
          )}
          <button type="button" className="ui-btn" onClick={onSave} disabled={saving}>
            {saving && <span className="ad-spinner" aria-hidden="true" />}
            {t("Save")}
          </button>
        </footer>
      )}
    </section>
  );
};

export default SectionCard;
